import React, {Component} from 'react';
import {Box, Hidden} from "@material-ui/core";
import AvatarCircleComponent from "../../../../Components/AvatarCircleComponent/AvatarCircleComponent";
import SpacerComponent from "../../../../Components/SpacerComponent/SpacerComponent";
import SearchTextFieldComponent from "../SearchTextFieldComponent/SearchTextFieldComponent";

class SubHeaderExtract extends Component {
    render() {
        return (
            <div>
                <Box display={'flex'}
                     justifyContent={'center'}
                     alignItems={'center'}>
                    <Hidden xsDown={true}
                            smDown={true}>
                        <Box display={'flex'}
                             flexDirection={'row'}
                             justifyContent={'flex-start'}
                             alignItems={'flex-start'}
                             flex={1}>
                            {/*<AvatarCircleComponent/>
                            <SpacerComponent width={20}/>*/}
                            <SearchTextFieldComponent/>
                        </Box>
                    </Hidden>
                    <Hidden lgUp={true}
                            xlUp={true}
                            mdUp={true}>
                        <Box display={'flex'}
                             flexDirection={'column'}
                             justifyContent={'center'}
                             alignItems={'center'}
                             flex={1}>
                            {/*<AvatarCircleComponent/>
                            <SpacerComponent height={20}/>*/}
                            <SearchTextFieldComponent/>
                        </Box>
                    </Hidden>
                </Box>
            </div>
        );
    }
}

export default SubHeaderExtract;